import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=e3bee1e6&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/productDetail.css?vue&type=style&index=0&id=e3bee1e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bee1e6",
  null
  
)

export default component.exports